import styled from "styled-components";
import { RollFromLeft } from "./animations";

const TileImage = styled.div`
  background-image: ${({ src }) => `url(${src})`};
  background-position: ${p=>p.position || "center"};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: fixed;
  height: ${({ height }) => `calc(100% / ${height})`};
  position: relative;
  transform: ${p => p.flip? "scaleX(-1)" : "none"};
  animation: ${RollFromLeft} 1.75s ease;
  animation-delay: 0.2s;
  animation-fill-mode: backwards;
  &::before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.2);
  }
`;

export default TileImage;
